var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7999 34.4867C42.7932 36.33 40.1332 37.3567 37.4032 37.3334H14.8632C5.36652 36.6567 5.34319 22.8667 14.8632 22.19H14.9565C8.44652 4.08338 35.9565 -3.12662 39.1065 15.8667C47.9032 16.9867 51.4732 28.6767 44.7999 34.4867Z",
    fill: "#219653"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 48.9997C43.75 49.9563 42.9567 50.7497 42 50.7497H32.6667C32.55 50.7497 32.4567 50.7497 32.34 50.703C31.6633 52.4297 29.96 53.6663 28 53.6663C26.04 53.6663 24.3367 52.4297 23.66 50.703C23.5433 50.7497 23.45 50.7497 23.3333 50.7497H14C13.0433 50.7497 12.25 49.9563 12.25 48.9997C12.25 48.043 13.0433 47.2497 14 47.2497H23.3333C23.45 47.2497 23.5433 47.2497 23.66 47.2963C24.1267 46.083 25.0833 45.1263 26.2967 44.6597C26.25 44.543 26.25 44.4497 26.25 44.333V37.333H29.75V44.333C29.75 44.4497 29.75 44.543 29.7033 44.6597C30.9167 45.1263 31.8733 46.083 32.34 47.2963C32.4567 47.2497 32.55 47.2497 32.6667 47.2497H42C42.9567 47.2497 43.75 48.043 43.75 48.9997Z",
    fill: "#219653"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.2ae0d58c0468e01bcbbda908401788c5.svg";
export { ForwardRef as ReactComponent };